module.exports = __webpack_public_path__ + "img/body-bk.65856d48.webp";